import { Component } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { DealerService, SpinnerService, AuthenticationService } from '../services';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import { TopLayoutComponent } from '../layouts/top-layout.component';
import { ReturnMailer } from '../models';
import { Observable } from 'rxjs/Observable';
import { timer } from 'rxjs/observable/timer';


@Component({ templateUrl: 'manage-returnmailer.component.html' })
export class ManageReturnMailerComponent {
    pageTitle: any;
    returnMailerForm: FormGroup;
    private sub: Subscription;
    currentUser: any;
    ReturnMailer: any;
    msgSuccess: boolean = false;
    Message: any = '';
    timer: any;
    errorMsgCheck: boolean = false;
    private subscription: Subscription = new Subscription();
    errorMessage: string;
    oemType:string;
    constructor(
        private dealerService: DealerService,
        private fb: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        private spinnerService: SpinnerService,
        private authenticationService: AuthenticationService,
        private http: HttpClient) { }

    ngOnInit() {
        this.errorMsgCheck = true;
        this.oemType ="Lexus";
        this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
        this.pageTitle = "Manage Return Mailers"
        this.returnMailerForm = this.fb.group({
            returnMailer: ['', [Validators.required]]
        });
    }
    SubmitReturnMailers() {
        this.errorMsgCheck = true;
        this.spinnerService.start();
        let Totalvalue = this.returnMailerForm.value.returnMailer;
        let splittedArray = Totalvalue.split("|");
        //if(splittedArray.length >= 7){
            if(splittedArray.length == 9){
            this.ReturnMailer = new ReturnMailer();
            this.ReturnMailer.DealerCode = splittedArray[0];
            // this.ReturnMailer.FirstName = splittedArray[1];
            // this.ReturnMailer.LastName = splittedArray[2];
            this.ReturnMailer.CustomerGuid =splittedArray[1];
            this.ReturnMailer.FullName =splittedArray[2];
            this.ReturnMailer.Address1 = splittedArray[3];
            this.ReturnMailer.Address2 = splittedArray[4];
            this.ReturnMailer.City = splittedArray[5];
            this.ReturnMailer.State = splittedArray[6];
            if( splittedArray[7].indexOf('-') > 0 ) {
                let splittedZipArray = splittedArray[7].split("-");
                this.ReturnMailer.ZipCode = splittedZipArray[0];
                this.ReturnMailer.ZipCode4 = splittedZipArray[1];
            }else{
                this.ReturnMailer.ZipCode = splittedArray[7];
            }
            
            this.ReturnMailer.Vin = splittedArray[8];
           // this.ReturnMailer.CustomerId = splittedArray[9];
            this.ReturnMailer.CreatedBy = this.currentUser.userName;
            if(this.oemType ="Non-Lexus")
            {
                this.ReturnMailer.IsLexus= false;
            }
            else{
                this.ReturnMailer.IsLexus= true;
            }
           
            if(this.ReturnMailer.DealerCode != "" && this.ReturnMailer.DealerCode != null){
                this.dealerService.getOrgIdBySrcDealerCode(this.ReturnMailer.DealerCode).subscribe(
                    (result: ReturnMailer) => {
                        var resu = result;
                        if(result[0]){
                           this.ReturnMailer.OrgId = result[0].OrgId;
                         
                          this.UpdateReturnMailer();
                             
                        }else{
                            this.ReturnMailer.OrgId='';
                           this.UpdateReturnMailer();
                        //    this.errorMsgCheck = false;
                        //    this.errorMessage = '<span class="text-danger">Invalid Dealer Code</span>';
                        }
                        this.spinnerService.stop();   
                   },
                   error => { 
                        this.errorMsgCheck = false;
                        this.errorMessage = '<span class="text-danger">Bad request</span>';
                        this.spinnerService.stop(); 
                    });
       
            }else{
                this.UpdateReturnMailer();
                // this.errorMsgCheck = false;
                // this.errorMessage = '<span class="text-danger">Invalid Dealer Code</span>';
                this.spinnerService.stop(); 
            }
            /* Old code - Saving Return mailers in C1_list  */
            /*
                this.dealerService.saveReturnMailers(this.ReturnMailer).subscribe(
                (mngRetmail: ReturnMailer) => {
                    this.onSaveComplete();
                    error => { this.spinnerService.stop(); }
                });
            */
           
        }else{
            this.spinnerService.stop(); 
            this.errorMsgCheck = false;
            this.errorMessage = '<span class="text-danger">Please enter valid mailer address, format sholud be in DealerCode|RecipientGUID|FullName|Address1|Address2|City|State|Zip|VIN</span>';
           // DealerCode|RecipientGUID|FullName|Address1|Address2|City|State|Zip|VIN
        }
        
    }
    UpdateReturnMailer(){
        
        this.dealerService.UpdateCustReturnMailer(this.ReturnMailer).subscribe(
            (message) => {
                 this.errorMsgCheck = false;
                 if(message != null && message != "" ){
                     if(message == "Updated successfully"){
                        (<FormControl> this.returnMailerForm.controls['returnMailer']).setValue('');
                        this.oemType ="Lexus";
                        setTimeout(()=>{ this.errorMsgCheck = true}, 4000);
                         this.errorMessage = '<span class="text-success">'+ message+"</span>";
                    
                     }else{
                         this.errorMessage = '<span class="text-danger">'+ message+"</span>";
                     }
                    
                 }else{
                     this.errorMessage = '<span class="text-danger">Invalid request, Please try after some time.</span>';
                 }
                 this.spinnerService.stop();
                    error => { this.spinnerService.stop(); }
            },
            error => { 
                 this.errorMsgCheck = false;
                 this.errorMessage = '<span class="text-danger">Bad request</span>';
                 this.spinnerService.stop(); 
             });
    }
    onSaveComplete(): void {
        this.msgSuccess = true;
        this.Message = "Saved Successfully.";
        this.spinnerService.stop();
        this.timer = timer(1000, 1000);
        this.subscription.add(this.timer.subscribe(t =>
            this.router.navigate(['/dealer/home'])));

    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}